import AccordionItem from "./AccordionItem";

const TodaysSpecialMenu = () => {
  return (
    <section className="padding ">
      <p className="text-lightGreen volkhov md:text-[18px] sm:text-[16px] text-[14px] italic leading-[30px] text-center md:mt-[120px] mt-[50px] mb-[13px]">
        The Chef recommends it.
      </p>
      <h2 className="text-deepRed text-center font-bold volkhov md:text-[46px] sm:text-[35px] italic text-[25px] sm:mb-[110px] mb-[50px]">
        Chef's Special
      </h2>
      <section className="flex items-center md:flex-row flex-col justify-between lg:gap-[100px] gap-[50px]">
        <div className="flex justify-center flex-col sm:gap-[60px] gap-[30px]">
          <div className="max-w-[700px]">
            <p className="text-lightGreen sm:mb-[32px] mb-[15px] volkhov sm:text-[24px] text-[21px] italic sm:text-start text-center">
              Breakfast
            </p>

            <div>
              <AccordionItem
                titleColor={"lightGreen"}
                priceColor={"lightRed_100"}
                title={"American Breakfast"}
                price={"GHS 120"}
                content={
                  "4 fluffy pancakes maple syrup scrambled eggs and two bacon rashers. Add tea coffee or water. (Replace bacon with beef patty or chicken sausages)"
                }
              />
              <AccordionItem
                titleColor={"lightGreen"}
                priceColor={"lightRed_100"}
                title={"Americano"}
                price={"GHS 45"}
                content={""}
              />
              <AccordionItem
                titleColor={"lightGreen"}
                priceColor={"lightRed_100"}
                title={"Assorted Flavours"}
                price={"GHS 30"}
                content={""}
              />
              <AccordionItem
                titleColor={"lightGreen"}
                priceColor={"lightRed_100"}
                title={"Breakfast Tea"}
                price={"GHS 30"}
                content={""}
              />
            </div>
          </div>
          <div className="max-w-[700px]">
            <p className="text-lightGreen sm:mb-[32px] mb-[15px] volkhov sm:text-[24px] text-[21px] italic sm:text-start text-center">
              Star Mocktails
            </p>

            <AccordionItem
              titleColor={"lightGreen"}
              priceColor={"lightRed_100"}
              title={"Virgin Colada"}
              price={"GHS 65"}
              content={
                "Fresh pineapple, pineapple juice, cream freshmilk and coconut syrup"
              }
            />

            <AccordionItem
              titleColor={"lightGreen"}
              priceColor={"lightRed_100"}
              title={"Chapman"}
              price={"GHS 65"}
              content={
                "Often referred to as a non-alcoholic punch, Chapman is a sweet mix of gredine syrup orange juice, Cucumber, Lemon, Angostura biters and Fanta/Sprite"
              }
            />
            <div className="flex mt-[30px]">
              <a
                href="https://menu.starbitesgh.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="rounded-[50px] gap-[5px] lg:px-[20px] px-[15px] py-[9px] cursor-pointer border text-lightRed_100 lg:text-[18px] text-[15px] inter leading-[30px] hover:bg-lightRed_100 hover:text-white transition-all duration-300 font-[600]"
              >
                Explore Menu
              </a>
            </div>
          </div>
        </div>

        <img
          src="/images/food2.svg"
          alt=""
          className="md:w-[600px] w-full h-[500px] object-cover"
        />
      </section>

      <div className="flex items-center justify-end mt-[50px] mb-[-18px]">
        <img src="/images/flower-top.svg" alt="" className="" />
      </div>
    </section>
  );
};

export default TodaysSpecialMenu;
